<template>
    <div class="card">
        <div class="card-header mt-3">
            <h5 class="card-title text-center">Smart Catalog Search</h5>
            <hr>
        </div>
        <div class="card-body">
            <div class="thumbnail-wrapper">
                <img v-if="!thumbnailURL" src="@/assets/SmartSalesLogo.png">
                <img v-if="thumbnailURL" :src="thumbnailURL" class="image" alt="Selected Product Image">
            </div>


            <div class="mb-3">
                <label><b>Category</b></label>
                <div class="form-group">

                    <select class="form-control"
                            v-model="selectedCategoryId"
                            @change="getManufacturers">
                        <option v-for="item in catagories" :key="item.Id" :value="item.Id">{{ item.DisplayName }}</option>
                    </select>
                    <i class="fa fa-chevron-down"></i>
                </div>
            </div>

            <div class="mb-3">
                <label><b>Manufacturer</b></label>
                <div class="form-group">
                    <select class="form-control"
                            v-model="selectedManufacturerId"
                            @change="getProducts"
                            :disabled="selectedCategoryId === null">
                        <option v-for="item in manufacturers" :key="item.Id" :value="item.Id">{{ item.DisplayName }}</option>
                    </select>
                    <i class="fa fa-chevron-down"></i>
                </div>
            </div>

            <div class="product-datagrid-wrapper">
                <BasicDataGrid :dataSource="products"
                               :columns="datagridColumns"
                               :actions="actions"
                               :multiSelect="false"
                               :searchEntireGrid="false"
                               :key="datagridKey"
                               :showColumnSearchIcon="false"
                               :filterByColumn="false"
                               :smartCatalogSearchGrid="true"
                               @addProduct="handleAddProduct"
                               @viewImage="handleViewImage"
                               @viewSmartCatalog="handleViewSpecificProductInSmartCatalog"
                               height="250px"/>
            </div>

            <div class="btn btn-primary btn-block mt-2" v-show="selectedManufacturerHasSmartCatalog" @click="viewManufacturerCatalog">View Smart Catalog</div>
        </div>
    </div>
</template>

<script>
    import { mapState }   from 'vuex';
    import { LookupService, ProductService }  from '@/services'
    import BasicDataGrid  from '@/components/BasicDataGrid.vue';

    export default {
        name: "SmartCatalogSearch",
        data: () => {
            return {
                catagories: [],
                manufacturers:[],
                products: [],
                datagridKey: 0,
                selectedCategoryId: null,
                selectedManufacturerId: null,
                // selectedProduct: () => {
                //     return {
                //         // Id: '',
                //         ThumbnailURL: '',
                //     }
                // },
                thumbnailURL: '',
                datagridColumns: [
                    { text: 'Part #',      value: 'PartNumber',      width: '100px' },
                    { text: 'Product', value: 'Description',  width: '150px' },
                ],
                // gridUpdateKey: 0,
            }
        },
        components: {
           BasicDataGrid,
        },
        computed: {
            ...mapState(['currentUser']),
            selectedManufacturerHasSmartCatalog(){
                if (this.selectedManufacturerId === null) return false;

                let manf = this.manufacturers.filter(m => m.Id === this.selectedManufacturerId)[0];
                if (manf && manf.HasSmartCatalog){
                    return true;
                } else {
                    return false;
                }
            },
            actions(){
                let manf = this.manufacturers.filter(m => m.Id === this.selectedManufacturerId)[0];
                if (manf && manf.HasSmartCatalog){
                    return [
                        {
                            hint: 'Add Product',
                            icon: 'plus',
                            emit: 'addProduct',
                        },
                        {
                            hint: 'SmartCatalog',
                            icon: 'file',
                            emit: 'viewSmartCatalog',
                        },
                        {
                            hint: 'image',
                            icon: 'image',
                            emit: 'viewImage',
                        },
                    ]
                } else {
                    return [
                        {
                            hint: 'Add Product',
                            icon: 'plus',
                            emit: 'addProduct',
                        },
                        {
                            hint: 'image',
                            icon: 'image',
                            emit: 'viewImage',
                        },
                    ]
                }
            }
        },
        methods: {
            
            getCatagories(){
                LookupService.productCatagories().then(res => {
                    console.log(res)
                    this.catagories = res.sort(function(a, b) {
                        var textA = a.DisplayName.toUpperCase();
                        var textB = b.DisplayName.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                }).catch(err => {
                    console.error(err);
                })
            },
            getManufacturers(){
                this.selectedManufacturerId = null
                this.products = []
                this.manufacturers = [];
                this.thumbnailURL = null;
                if (this.selectedCategoryId === null) return;
                LookupService.productCatagoryManufacturers(this.selectedCategoryId).then(res => {
                    this.manufacturers = res;
                }).catch(err => {
                    console.error(err);
                })
            },
            getProducts(){
                this.thumbnailURL = null
                this.products = []
                if (this.selectedCategoryId === null || this.selectedManufacturerId === null) return;
                LookupService.productCatagoryManufacturersProducts(this.selectedCategoryId,this.selectedManufacturerId).then(res => {
                    this.products = res;
                    this.products.forEach(prod => {
                        // var str = prod.Description;
                        // var patt = "\uFFFD"
                        prod.Description = prod.Description.replace("\uFFFD", "'");
                    })
                }).catch(err => {
                    console.error(err);
                })
            },
            handleAddProduct($event){
                console.log('add product from search', $event.row.data)
                this.$emit('productAdded', $event.row.data)
                // add product to datagrid
            },
            // getProduct(imageData){
            //     ProductService.getImage(imageData).then(res => {
            //         console.log(res)
            //         this.thumbnailURL = res;
            //     }).catch(err => {
            //         this.thumbnailURL = '';
            //         this.$store.dispatch('ADD_NOTIFICATION', { text: `No image is available for this product`, type: 'error' });
            //         console.error(err);
            //     })
            // },
            handleViewImage($event){
                console.log($event)
                // let imageData = {
                //     StockCode: $event.row.data.StockCode,
                //     MfgId: $event.row.data.MfgId
                // }
                this.thumbnailURL = $event.row.data.ThumbnailURL
                // let productId = $event.row.data.Id;
                // if(productId === 0){
                //     this.$store.dispatch('ADD_NOTIFICATION', { text: `No image is available for this product`, type: 'error' });
                // }
                // this.getProduct(imageData);
            },
            handleViewSpecificProductInSmartCatalog($event){
                let product = $event.row.data;
                let index = this.manufacturers.map(mfg => mfg.Id).indexOf(this.selectedManufacturerId)
                let dealerMfgId = this.manufacturers[index].DealerMfgId;
                let dealerMfgCode = this.manufacturers[index].DealerMfgCode;
                let data = {
                    manufacturerId: this.selectedManufacturerId,
                    dealerMfgId: dealerMfgId,
                    dealerMfgCode: dealerMfgCode,
                    product: product,
                };
                this.$emit('selected:manufacturer:product',data);
            },
            viewManufacturerCatalog(){
                let index = this.manufacturers.map(mfg => mfg.Id).indexOf(this.selectedManufacturerId)
                console.log('index', index, this.manufacturers)
                let dealerMfgId = this.manufacturers[index].DealerMfgId;
                let dealerMfgCode = this.manufacturers[index].DealerMfgCode;
                this.$emit('selected:manufacturer', this.selectedManufacturerId, dealerMfgId, dealerMfgCode);
            }
        },
        mounted(){
            this.getCatagories();
            this.getManufacturers();
        },
        watch: {
            selectedManufacturerId: function () {
                this.datagridKey++;
            }
        }
    }
</script>

<style scoped lang="scss">
    .image{
        max-width: 150px;
        max-height: 150px
    }
    .icon-btn{
        border: none;
        background-color: transparent;
        padding: 0px;
    }
    .thumbnail-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        min-height: 100px;
    }

    .card {
        min-width: 300px;
        max-width: 700px;
    }

    .product-datagrid-wrapper {
        /*max-height: 200px;*/
        padding: 10px;
    }

    .form-group{
        margin-bottom: 0px;

        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background:transparent;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            /*background-color: #fff; inherits from form-control*/
            padding-right: 5px;
        }
    }
</style>
